var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white bg-cover flex h-screen w-screen items-center justify-center login--container"},[_c('div',{staticClass:"grid w-full max-w-xl relative"},[_c('div',{staticClass:"text-center w-full"},[_c('img',{staticClass:"inline-block p-16",attrs:{"src":require('@/assets/logo-splash.png'),"alt":"Atabix demo"}})]),_c('div',{staticClass:"bg-secondary-500 mt-16 rounded-t-lg h-4"}),_c('div',{staticClass:"bg-white p-32 rounded-b shadow-md text-center col-start-1 col-end-2 row-start-3 row-end-4"},[_c('div',{staticClass:"mb-16 text-primary-500"},[_c('h1',{staticClass:"text-4xl font-bold"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"text-base mb-8"},[_vm._v(_vm._s(_vm.text))]),(_vm.passwordReset)?_c('v-icon',{staticClass:"text-6xl"},[_vm._v("mdi-lock-check")]):_vm._e()],1),_c('MiForm',{staticClass:"\n        w-5/6\n        xl:w-2/3\n        my-o mx-auto",attrs:{"fields":[
          {
            type: 'password',
            key: 'password',
            placeholder: 'Wachtwoord',
            disabled: false,
            rules: ['required'],
            debounced: true,
          },
          {
            type: 'password',
            key: 'password_confirmation',
            placeholder: 'Bevestig wachtwoord',
            disabled: false,
            rules: ['required'],
            debounced: true,
          }
        ],"options":{
          lazyValidation: false,
          theme: 'light',
        }},on:{"fieldChanged":_vm.handleFieldChanged}}),_c('mi-button',{attrs:{"options":{
          round: true,
          flat: true,
          icon: 'mdi-lock-reset',
          iconRight: true,
          label: 'Wachtwoord resetten',
          color: 'secondary',
          colorIntensity: '500',
          disabled:!_vm.canSubmit,
        }},on:{"click":_vm.resetPassword}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }